module.exports = __webpack_public_path__ + "static/media/lennumaa.ef20dfeb.svg";